import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Privacypolicy from "../Pages/Privacypolicy/Privacypolicy";
import Privacycenter from "../Pages/Privacypolicy/Privacycenter";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Privacytheme() {
  return (
    <>
      <Header />
      <Privacypolicy />
      <Privacycenter />
      <Footer />
    </>
  );
}
